import { Effect, RequestResolver } from 'effect';
import { Url } from '../../../api';
import { PutModularTemplateError } from '../service';
export const PutModularTemplateResolver = (http, tokenProvider, gavelUrl) => RequestResolver.fromEffect((request) => Effect.andThen(tokenProvider.getToken(), token => http.put(Url.join(gavelUrl, `/api/v1/${request.tenant}/modular-templates/${request.template.id}`), {
    authorization: `Bearer ${token}`,
    'content-type': 'application/json',
}, request.template)).pipe(Effect.mapError(e => new PutModularTemplateError({ originalError: e }))));
